import { render, staticRenderFns } from "./BookTags.vue?vue&type=template&id=7cbf518a&"
import script from "./BookTags.vue?vue&type=script&lang=js&"
export * from "./BookTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports